export enum CalendarEventType {
  ShopVisit = 'ShopVisit',
  OtherMeeting = 'OtherMeeting'
}

export enum CalendarInspectionType {
  CurbAppeal = 'CurbAppeal',
  Showroom = 'Showroom'
}

export const CalendarInspectionTypeToLabel: { [key: string]: string } = {
  CurbAppeal: 'Curb appeal inspection',
  Showroom: 'Showroom inspection'
}
